import React from 'react';
import * as PropTypes from 'prop-types';
import { Select } from 'antd';
import { Icon } from '@ant-design/compatible';
import MemberDropdown from './MemberDropdown';
import RemoveButtonGroup from './RemoveButtonGroup';
import FilterInput from './FilterInput';

const DATE_OPERATORS = [
  { name: 'equals', title: 'on' },
  { name: 'notEquals', title: 'not on' },
  { name: 'gt', title: 'after' },
  { name: 'gte', title: 'on or after' },
  { name: 'lt', title: 'before' },
  { name: 'lte', title: 'on or before' },
];

// Label for filter dimension: prefer display name, fallback to field name when only id (e.g. "cube.field") is set
function getFilterDimensionLabel(dimension, availableMembers) {
  if (dimension.displayTitle) return dimension.displayTitle;
  if (dimension.title && dimension.title !== dimension.name) return dimension.title;
  if (availableMembers && dimension.name) {
    const found = availableMembers.find((m) => m.name === dimension.name);
    if (found) return found.displayTitle ?? found.title ?? dimension.name;
  }
  // Raw id like "transactions_view.occ" -> show "occ" or last segment
  if (dimension.name && String(dimension.name).includes('.')) {
    return String(dimension.name).split('.').pop();
  }
  return dimension.title || dimension.name || '';
}

const FilterGroup = ({
  members,
  availableMembers,
  addMemberName,
  updateMethods,
}) => (
  <span>
    {members.map((m) => {
      const isDateDimension = m.dimension?.type === 'time';
      const operators = isDateDimension ? DATE_OPERATORS : (m.operators || []);
      const operator = operators.some((op) => op.name === m.operator)
        ? m.operator
        : operators[0]?.name;
      return (
      <div
        style={{
          marginBottom: 12,
        }}
        key={m.index}
      >
        <RemoveButtonGroup onRemoveClick={() => updateMethods.remove(m)}>
          <MemberDropdown
            onClick={(updateWith) =>
              updateMethods.update(m, {
                ...m,
                dimension: updateWith,
              })
            }
            availableMembers={availableMembers}
            style={{
              width: 150,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {getFilterDimensionLabel(m.dimension, availableMembers)}
          </MemberDropdown>
        </RemoveButtonGroup>
        <Select
          value={operator}
          onChange={(op) =>
            updateMethods.update(m, {
              ...m,
              operator: op,
            })
          }
          style={{
            width: 200,
            marginRight: 8,
          }}
        >
          {operators.map((o) => (
            <Select.Option key={o.name} value={o.name}>
              {o.title}
            </Select.Option>
          ))}
        </Select>
        <FilterInput
          member={m}
          key="filterInput"
          updateMethods={updateMethods}
        />
      </div>
      );
    })}
    <MemberDropdown
    // This is the add filter button
      onClick={(m) => {
        // This is the add filter button
        // Ensure filter is initialized with required fields
        const defaultOperator = m.operators && m.operators.length > 0 
          ? m.operators[0].name 
          : 'equals';
        updateMethods.add({
          dimension: m,
          operator: defaultOperator,
          values: [],
        });
      }}
      availableMembers={availableMembers}
      type="dashed"
      icon={<Icon type="plus" />}
    >
      {addMemberName}
    </MemberDropdown>
  </span>
);
FilterGroup.propTypes = {
  members: PropTypes.array.isRequired,
  availableMembers: PropTypes.array.isRequired,
  addMemberName: PropTypes.string.isRequired,
  updateMethods: PropTypes.object.isRequired,
};
export default FilterGroup;
